import { Typography } from '@mui/material';

export default function BoldText({txt}) {
    return (
        <Typography display="inline" sx={{color:"#A26769"}}> {txt} </Typography> 
    );
}